import { render, staticRenderFns } from "./subscribeAirPortPushRuleView.vue?vue&type=template&id=70371822&scoped=true&"
import script from "./subscribeAirPortPushRuleView.vue?vue&type=script&lang=js&"
export * from "./subscribeAirPortPushRuleView.vue?vue&type=script&lang=js&"
import style0 from "./subscribeAirPortPushRuleView.vue?vue&type=style&index=0&id=70371822&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70371822",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70371822')) {
      api.createRecord('70371822', component.options)
    } else {
      api.reload('70371822', component.options)
    }
    module.hot.accept("./subscribeAirPortPushRuleView.vue?vue&type=template&id=70371822&scoped=true&", function () {
      api.rerender('70371822', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/subscribeAirPortPushRuleView.vue"
export default component.exports